import { useDocumentPreviewVM } from "presentation/hook/DocumentPreview/useDocumentPreviewVM";
import { useDocumentPreviewTracked } from "presentation/store/DocumentPreview/DocumentPreviewProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";


export const DocumentPreviewEditForm = () => {
  const [documentPreviewState] = useDocumentPreviewTracked();
  const documentPreviewVM = useDocumentPreviewVM();
  const { poNo, ourRef, yourRef, remarks } = documentPreviewState;
  return (
    <>
      <div className={'im-flex-row'}>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
          <NbisCommonField
            errorMessages={{}}
            isReadOnly={false}
            isShowOptional={false}
            readOnlyValue={poNo || ''}
            fieldValue={poNo}
            fieldLabel={'Update P.O. No.'}
            isSaveClicked={false}
            fieldType={FieldType.TEXT}
            fieldKey={'poNo'}
            maxLength={50}
            isTextFieldCapitalize={false}
            requiredFieldList={[]}
            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
              documentPreviewVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
      </div>
      <div className={'im-flex-row'}>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
          <NbisCommonField
            errorMessages={{}}
            isReadOnly={false}
            isShowOptional={false}
            readOnlyValue={ourRef || ''}
            fieldValue={ourRef}
            fieldLabel={'Update Our Ref.'}
            isSaveClicked={false}
            fieldType={FieldType.TEXT}
            fieldKey={'ourRef'}
            maxLength={50}
            isTextFieldCapitalize={false}
            requiredFieldList={[]}
            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
              documentPreviewVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
      </div>
      <div className={'im-flex-row'}>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
          <NbisCommonField
            errorMessages={{}}
            isReadOnly={false}
            isShowOptional={false}
            readOnlyValue={yourRef || ''}
            fieldValue={yourRef}
            fieldLabel={'Update Your Ref.'}
            isSaveClicked={false}
            fieldType={FieldType.TEXT}
            fieldKey={'yourRef'}
            maxLength={50}
            isTextFieldCapitalize={false}
            requiredFieldList={[]}
            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
              documentPreviewVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
      </div>
      <div className={'im-flex-row'}>
        <div className='im-flex-row-item' style={{ width: "330px" }}>
          <NbisCommonField
            errorMessages={{}}
            isReadOnly={false}
            isShowOptional={false}
            readOnlyValue={remarks || ''}
            fieldValue={remarks}
            fieldLabel={'Remarks'}
            isSaveClicked={false}
            fieldType={FieldType.TEXT}
            fieldKey={'remarks'}
            maxLength={50}
            isTextFieldCapitalize={false}
            requiredFieldList={[]}
            onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
              documentPreviewVM.onEditFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
      </div>
    </>
  )
}
